import { Navigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2, LogIn } from "lucide-react";

/** Détecte si l'app est chargée dans un iframe (WordPress / preview Emergent). */
function isEmbedded() {
  try { return window.self !== window.top; } catch (_) { return true; }
}

export default function ProtectedRoute({ children, admin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    // En iframe : on n'utilise PAS Navigate (qui peut être bloquée par l'historique
    // parent). On affiche un écran inline avec un lien client-side vers /login,
    // ce qui garantit qu'on reste dans l'iframe sans jamais toucher window.top.
    if (isEmbedded()) {
      return (
        <div data-testid="session-expired-screen" className="min-h-[70vh] flex items-center justify-center px-6">
          <div className="paper p-8 max-w-md w-full text-center space-y-4">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
              <LogIn className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h2 className="font-heading text-2xl mb-1">Session expirée</h2>
              <p className="text-sm text-muted-foreground">
                Reconnectez-vous pour retrouver vos devis et poursuivre votre configuration.
              </p>
            </div>
            <Link
              data-testid="reconnect-cta"
              to="/login"
              state={{ from: location }}
              className="btn-primary inline-flex items-center gap-2 justify-center w-full"
            >
              <LogIn className="w-4 h-4" /> Se reconnecter
            </Link>
          </div>
        </div>
      );
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (admin && user.role !== "admin") {
    return <Navigate to="/configurateur" replace />;
  }
  return children;
}
